export class ABCList {
    constructor() {
        this.masonry(".abc-list .wrapper");
        window.addEventListener('resize', () => this.masonry(".abc-list .wrapper"));
    }

    public masonry(wrapper: string): void {
        const wrapperElement = document.querySelector(wrapper);
        if (wrapperElement){
            const children = wrapperElement.children;
            let childrenHeights = [];
            let totalHeight = 0;
            // @ts-ignore
            for (const child of children) {
                totalHeight = totalHeight + child.offsetHeight;
                childrenHeights.push(child.offsetHeight);
            }
            const largestChild = Math.max(...childrenHeights);

            if (window.innerWidth >= 1200) {
                totalHeight = (totalHeight + largestChild) / 3;
            } else if (window.innerWidth <= 1200 && window.innerWidth >= 782) {
                totalHeight = (totalHeight + largestChild) / 2;
            }
            wrapperElement.setAttribute("style", `max-height: ${totalHeight}px`);
        }
    }
}
